import TextField from '@mui/material/TextField'
import {withStyles} from '@mui/styles'
import {Colors} from './index'

export const INPUT_STYLES = theme => ({
  root: {
    '& label': {
      color: theme.palette.primary.main,
      padding: '2px 4px',
    },
    '& label.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '& label.Mui-disabled': {
      color: Colors.rxrDarkGreyColor,
    },
    '& label.Mui-error': {
      color: Colors.rxrRedColor,
    },
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      backgroundColor: Colors.rxrWhiteColor,
      '& fieldset': {
        border: '1px solid',
        borderColor: theme.palette.primary.main,
      },
      '&:hover fieldset': {
        border: '1px solid',
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-disabled fieldset': {
        border: '1px solid',
        borderColor: Colors.rxrMediumLightGreyColor,
      },
      '&.Mui-focused fieldset': {
        border: '1px solid',
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-error fieldset': {
        border: '1px solid',
        borderColor: Colors.rxrRedColor,
      },
      '& .MuiInputAdornment-root': {
        '& .MuiIconButton-root': {
          '&:focus': {
            outline: '0px auto transparent',
          },
        },
      },
    },
    '& .MuiInputBase-root': {
      color: theme.palette.primary.main,
      '&.Mui-disabled': {
        backgroundColor: Colors.rxrLightGreyColor,
        color: Colors.rxrDarkGreyColor,
      },
      '&.Mui-error': {
        color: Colors.rxrRedColor,
      },
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiFormHelperText-root': {
      color: theme.palette.primary.main,
      '&.Mui-disabled': {
        color: Colors.rxrDarkGreyColor,
      },
      '&.Mui-error': {
        color: Colors.rxrRedColor,
      },
    },
  },
})

export const FormTextField = withStyles(INPUT_STYLES)(TextField)
